"use strict";

const globals = {
  breakpoint: 960
};

export default globals;
